<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2019 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2019</p>
<p class="crt">Printed in China</p>
<p class="crtf">28 27 26 25 24 23 22 21 20 19    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-64961-0 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-64975-7 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-64989-4 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226649894.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226649894.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Hoeckner, Berthold, author.</p>
<p class="cip">Title: Film, music, memory / Berthold Hoeckner.</p>
<p class="cip">Description: Chicago : University of Chicago Press, 2019. | Includes index.</p>
<p class="cip">Identifiers: LCCN 2019018466 | ISBN 9780226649610 (cloth) | ISBN 9780226649757 (paperback) | ISBN 9780226649894 (ebook)</p>
<p class="cip">Subjects: LCSH: Motion picture music—History and criticism. | Memory in motion pictures.</p>
<p class="cip">Classification: LCC ML2075 .H615 2019 | DDC 781.5/42—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2019018466" target="_blank">https://lccn.loc.gov/2019018466</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI/NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hoeckner-0005.vue?b5e33bac